import { __extends } from "tslib";
import { EventBase } from './EventBase';
var ProjectionEvent = /** @class */ (function (_super) {
    __extends(ProjectionEvent, _super);
    function ProjectionEvent(type, projection) {
        var _this = _super.call(this, type) || this;
        _this._projection = projection;
        return _this;
    }
    Object.defineProperty(ProjectionEvent.prototype, "projection", {
        get: function () {
            return this._projection;
        },
        enumerable: true,
        configurable: true
    });
    ProjectionEvent.INVALIDATE_FRUSTUM_MATRIX3D = 'invalidateFrustumMatrix3D';
    ProjectionEvent.INVALIDATE_VIEW_MATRIX3D = 'invalidateViewMatrix3D';
    return ProjectionEvent;
}(EventBase));
export { ProjectionEvent };
